(function(w){
    //去掉字符串首尾空格
    String.prototype.trim=function(){
        return this.replace(/(^\s*)|(\s*$)/g,"");
    };
    //去掉字符串首尾空格
    String.prototype.trimAll=function(){
        return this.replace(/\s+/g,"");
    };
    //验证必填项
    String.prototype.required=function(){
        var v=this.trim();
        if(v===""){
            return false;
        }
        return true;
    };
    //只能为数字
    String.prototype.common_check_number=function(){
        var reg = /^\d+$/;
        var v=this.trim();
        if(!reg.test(v)){
            return false;
        }
        return true;
    };
    //只能为中文
    String.prototype.common_check_chinese=function(){
        var reg = /^[\u4e00-\u9fa5]+$/;
        var v=this.trim();
        if(!reg.test(v)){
            return false;
        }
        return true;
    };
    //只能为营业执照公司名称(>5个字符)
    String.prototype.common_check_corp_name=function(){
        var reg = /^[\u4e00-\u9fa5]+([\（\(][\u4e00-\u9fa5]+[\）|\)])*[\u4e00-\u9fa5]*$/;
        var v=this.trim();
        if(!reg.test(v) || v.length<=5){
            return false;
        }
        return true;
    };
    //中文姓名(>1个字符)
    String.prototype.common_check_chinese_name=function(){
        var reg = /^[\u4e00-\u9fa5]+$/;
        var v=this.trim();
        if(!reg.test(v) || v.length<=1){
            return false;
        }
        return true;
    };
    //只能包含字母和数字
    String.prototype.common_check_en_num=function(){
        var reg = /^[a-zA-Z0-9]+$/;
        var v=this.trim();
        if(!reg.test(v)){
            return false;
        }
        return true;
    };
    //验证密码(8-18位，只能包含字母、数字和下划线)
    String.prototype.common_check_password=function(){
        var reg = new RegExp(/(?=.*[0-9])(?=.*[a-zA-Z]).{8,18}/);
        var v=this.trim();
        if(!reg.test(v)){
            return false;
        }
        return true;
    };
    //验证固定电话号码
    String.prototype.common_check_telephone=function(){
        var reg = /^((0\d{2,3})-?)(\d{7,8})(-(\d{1,4}))?$/;
        var v=this.trim();
        if(!reg.test(v)){
            return false;
        }
        return true;
    };
    //验证手机号码
    String.prototype.common_check_mobile=function(){
        var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        var v=this.trim();
        if(!reg.test(v)){
            return false;
        }
        return true;
    };
    //验证身份证号码
    String.prototype.common_check_idCard=function(){
        var reg1 = /^\d{8}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}$/i;
        var reg2 = /^\d{6}((19)|(20))\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/i;
        var v=this.trim();
        if(reg1.test(v)){
            return true;
        }
        else if(reg2.test(v)){
            return true;
        }
        else{
            return false;
        }
    };
    //验证身份证有效截止日期(如:20180909或长期)
    String.prototype.common_check_date_a=function(){
        var reg = /^([2][0][1-9][0-9](([0][1-9])|([1][0-2]))(([0][1-9])|(([1-2][0-9])|([3][0-1]))))|([长][期])$/i;
        var v=this.trim();
        if(!reg.test(v)){
            return false;
        }
        return true;
    };
    //验证邮箱
    String.prototype.common_check_email=function(){
        var reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
        var v=this.trim();
        if(!reg.test(v)){
            return false;
        }
        return true;
    };
    //格式化日期
    //String(unix时间戳 string)
    String.prototype.formatDate=function(){
        var t,y,m,d,h,i,s;
        t=new Date(parseInt(this));
        y=t.getFullYear();
        m=t.getMonth()+1;
        d=t.getDate();
        h=t.getHours();
        i=t.getMinutes();
        s=t.getSeconds();
        var ft="y-m-d h:i:s";
        var fa=ft.split(" ");
        var aa=fa[0]?fa[0].split("-"):[];
        var bb=fa[1]?fa[1].split(":"):[];
        var cc=aa.concat(bb);
        var ds="";
        for(var e=0;e<cc.length;e++){
            switch(cc[e]){
                case "y":
                    ds+=y;
                    break;
                case "m":
                    ds+="-"+(m<10?'0'+m:m);
                    break;
                case "d":
                    ds+="-"+(d<10?'0'+d:d);
                    break;
                case "h":
                    ds+=" "+(h<10?'0'+h:h);
                    break;
                case "i":
                    ds+=":"+(i<10?'0'+i:i);
                    break;
                case "s":
                    ds+=":"+(s<10?'0'+s:s);
                    break;
                default:
                    break;
            }
        }
        return ds;
    };
    //格式化日期
    //Number(unix时间戳 int)
    Number.prototype.formatDate=function(){
        var t,y,m,d,h,i,s;
        t=new Date(parseInt(this));
        y=t.getFullYear();
        m=t.getMonth()+1;
        d=t.getDate();
        h=t.getHours();
        i=t.getMinutes();
        s=t.getSeconds();
        var ft="y-m-d h:i:s";
        var fa=ft.split(" ");
        var aa=fa[0]?fa[0].split("-"):[];
        var bb=fa[1]?fa[1].split(":"):[];
        var cc=aa.concat(bb);
        var ds="";
        for(var e=0;e<cc.length;e++){
            switch(cc[e]){
                case "y":
                    ds+=y;
                    break;
                case "m":
                    ds+="-"+(m<10?'0'+m:m);
                    break;
                case "d":
                    ds+="-"+(d<10?'0'+d:d);
                    break;
                case "h":
                    ds+=" "+(h<10?'0'+h:h);
                    break;
                case "i":
                    ds+=":"+(i<10?'0'+i:i);
                    break;
                case "s":
                    ds+=":"+(s<10?'0'+s:s);
                    break;
                default:
                    break;
            }
        }
        return ds;
    };
    //格式化日期--只精确到天
    //Number(unix时间戳 int)
    Number.prototype.formatOnlyDate=function(){
        var t,y,m,d,h,i,s;
        t=new Date(parseInt(this));
        y=t.getFullYear();
        m=t.getMonth()+1;
        d=t.getDate();
        h=t.getHours();
        i=t.getMinutes();
        s=t.getSeconds();
        var ft="y-m-d h:i:s";
        var fa=ft.split(" ");
        var aa=fa[0]?fa[0].split("-"):[];
        var bb=fa[1]?fa[1].split(":"):[];
        var cc=aa.concat(bb);
        var ds="";
        for(var e=0;e<cc.length;e++){
            switch(cc[e]){
                case "y":
                    ds+=y;
                    break;
                case "m":
                    ds+="-"+(m<10?'0'+m:m);
                    break;
                case "d":
                    ds+="-"+(d<10?'0'+d:d);
                    break;

                default:
                    break;
            }
        }
        return ds;
    };
    //格式化金额
    //String(数字字符串,可以带小数点)
    String.prototype.formatMoney=function(n,r){
        var obj=this.replace(/[a-zA-Z\;\:\`\~\!\@\#\$\%\^\&\*\(\)\_\+\-\=\[\]\{\}\\\|\'\"\<\,\>\?\/]/g,"");
        obj=obj.replace(/\.{2,}/g,".");
        var newNum="";
        var dotNum=n?parseInt(n):2;//保留小数点位数
        var ifRound=r?r:true;//是否四舍五入
        if(obj.indexOf(".")>=0){
            var strArr=obj.split(".");
            var inter=strArr[0]?parseInt(strArr[0]):0;
            var decimaler=strArr[1];
            var houNum="";
            if(ifRound){
                houNum="0.";
                for(var i=0;i<=dotNum;i++){
                    var gg=typeof(decimaler[i])!="undefined"?decimaler[i]:"0";
                    houNum+=gg;
                }
                houNum=parseFloat(houNum);
                houNum=Math.round(houNum*Math.pow(10,dotNum))/Math.pow(10,dotNum);
                if(houNum>0){
                    if(houNum==1){
                        inter=inter+1;
                        houNum="0.";
                    }
                    else{
                        houNum=houNum+"";
                    }
                    if(houNum.length-2<dotNum){
                        var q=dotNum-(houNum.length-2);
                        for(var i=0;i<q;i++){
                            houNum+="0";
                        }
                    }
                    houNum=houNum.substring(1);
                }
                else{
                    houNum="";
                }
            }
            else{
                houNum=".";
                for(var i=0;i<dotNum;i++){
                    var gg=typeof(decimaler[i])!="undefined"?decimaler[i]:"0";
                    houNum+=gg;
                }
            }
            inter=inter+"";
            var s=1;
            var v=[];
            for(var i=inter.length-1;i>=0;i--){
                v.push(inter[i]);
                if(s==3){
                    v.push(",");
                    s=1;
                }
                else{
                    s=s+1;
                }
            }
            for(var i=v.length-1;i>=0;i--){
                newNum+=v[i];
            }
            newNum=newNum.replace(/(^\,*)|(\,*$)/g,"");
            newNum=newNum+houNum;
        }
        else{
            var s=1;
            var v=[];
            for(var i=obj.length-1;i>=0;i--){
                v.push(obj[i]);
                if(s==3){
                    v.push(",");
                    s=1;
                }
                else{
                    s=s+1;
                }
            }
            for(var i=v.length-1;i>=0;i--){
                newNum+=v[i];
            }
            newNum=newNum.replace(/(^\,*)|(\,*$)/g,"");
            if(dotNum>0){
                newNum+=".";
                for(var i=0;i<dotNum;i++){
                    newNum+="0";
                }
            }
        }
        return newNum;
    };
    //金额转换成汉字
    //String(数字字符串,可以带一个小数点)
    String.prototype.moneyCapital=function(){
        var num=this.replace(/[a-zA-Z\;\:\`\~\!\@\#\$\%\^\&\*\(\)\_\+\-\=\[\]\{\}\\\|\'\"\<\,\>\?\/]/g,"");
        num=num.replace(/\.{2,}/g,".");
        var strOutput="";
        var strUnit='仟佰拾亿仟佰拾万仟佰拾元角分';
        num+="00";
        var intPos=num.indexOf('.');
        if(intPos>=0){
            num=num.substring(0,intPos)+num.substr(intPos+1,2);
        }
        strUnit=strUnit.substr(strUnit.length-num.length);
        for(var i=0;i<num.length;i++){
            strOutput+='零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i,1),1)+strUnit.substr(i,1);
        }
        return strOutput.replace(/零角零分$/,'整').replace(/零[仟佰拾]/g,'零').replace(/零{2,}/g,'零').replace(/零([亿|万])/g,'$1').replace(/零+元/,'元').replace(/亿零{0,3}万/,'亿').replace(/^元/,"零元");
    };
    //判断访问来源设备、浏览器名称、浏览器版本
    //返回object{"dName":dName,"bStyle":bStyle,"bVersion":bVersion}
    w.browserInfo=function(){
        var userAgent=navigator.userAgent.toLowerCase();
        var dName="pc";
        var bStyle="undefined";
        var bVersion="undefined";
        var isIE6=userAgent.indexOf("msie 6.0")>-1;
        if(isIE6==true){
            bStyle="IE";
            bVersion="6.0";
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isIE7=userAgent.indexOf("msie 7.0")>-1;
        if(isIE7==true){
            bStyle="IE";
            bVersion="7.0";
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isIE8=userAgent.indexOf("msie 8.0")>-1;
        if(isIE8==true){
            bStyle="IE";
            bVersion="8.0";
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isIE9=userAgent.indexOf("msie 9.0")>-1;
        if(isIE9==true){
            bStyle="IE";
            bVersion="9.0";
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isIE10=userAgent.indexOf("msie 10.0")>-1;
        if(isIE10==true){
            bStyle="IE";
            bVersion="10.0";
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isIE11=userAgent.indexOf("rv:11.0) like gecko")>-1;
        if(isIE11==true){
            bStyle="IE";
            bVersion="11.0";
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isEdge=userAgent.indexOf("edge/")>-1;
        if(isEdge==true){
            bStyle="edge";
            var agent_array=userAgent.split("edge/");
            var version_array=agent_array[1].split(" ");
            var result_version=version_array[0];
            bVersion=result_version;
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var is360=userAgent.indexOf("qihu")>-1||userAgent.indexOf("360se")>-1;
        if(is360==true){
            bStyle="360";
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isOpera1=userAgent.indexOf("opr/")>-1;
        if(isOpera1==true){
            bStyle="opera";
            var agent_array=userAgent.split("opr/");
            var version_array=agent_array[1].split(" ");
            var result_version=version_array[0];
            bVersion=result_version;
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isOpera2=userAgent.indexOf("opera/")>-1;
        if(isOpera2==true){
            bStyle="opera";
            var agent_array=userAgent.split("opera/");
            var version_array=agent_array[1].split(" ");
            var result_version=version_array[0];
            bVersion=result_version;
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isChrome=userAgent.indexOf("chrome/")>-1;
        if(isChrome==true){
            bStyle="chrome";
            var agent_array=userAgent.split("chrome/");
            var version_array=agent_array[1].split(" ");
            var result_version=version_array[0];
            bVersion=result_version;
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isFirefox=userAgent.indexOf("firefox/")>-1;
        if(isFirefox==true){
            bStyle="firefox";
            var agent_array=userAgent.split("firefox/");
            var version_array=agent_array[1].split(" ");
            var result_version=version_array[0];
            bVersion=result_version;
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        var isSafari=userAgent.indexOf("safari/")>-1;
        if(isSafari==true){
            bStyle="safari";
            var agent_array=userAgent.split("safari/");
            var version_array=agent_array[1].split(" ");
            var result_version=version_array[0];
            bVersion=result_version;
            return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
        }
        return {"dName":dName,"bStyle":bStyle,"bVersion":bVersion};
    };
    var _b=w.browserInfo();
    if(_b.bStyle==="IE"){
        if(_b.bVersion==="6.0"||_b.bVersion==="7.0"||_b.bVersion==="8.0"){
            w.location.href="101.html";
        }
    }
    //判断是否http并重定向为https
    w.changeHttpToHttps=function(){
        var _this_url=w.location.href.toLowerCase();
        var _this_pro=w.location.protocol.toLowerCase();
        if(_this_url.indexOf("//uat.keking.cn")>-1 || _this_url.indexOf("//i.keking.cn")>-1){
            if(_this_pro=="http:"){
                var _url_arr=_this_url.split("://");
                _url_arr.shift();
                var _url_base=_url_arr.join("");
                var _that_url="https://"+_url_base;
                w.location.href=_that_url;
            }
        }
    };
    w.changeHttpToHttps();
    //判断是否为null
    w.thisIsNull=function(o){
        return Object.prototype.toString.call(o) === "[object Null]";
    };
    //判断是否为js对象字面量
    w.thisIsObject=function(o){
        return Object.prototype.toString.call(o) === "[object Object]";
    };
    //判断是否为js数组字面量
    w.thisIsArray=function(o){
        return Object.prototype.toString.call(o) === "[object Array]";
    };
    //判断是否为js函数
    w.thisIsFunction=function(o){
        return Object.prototype.toString.call(o) === "[object Function]";
    };
    //获取随机字符串
    w.getCommonId=function(){
        var len=32;//长度
        var chars='123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        var commonId=[],i;
        for(i=0;i<len;i++){
            commonId[i]=chars[0|Math.random()*chars.length];
        }
        return commonId.join('');
    };
    //获取URL中指定查询字符串的值
    w.getQueryValue=function(name){
        var _this=w.location.search;
        var regExp = new RegExp("(^|&)"+name+"=([^&]*)(&|$)","i");
        var result = _this.substr(1).match(regExp);
        if (result != null){
            return decodeURIComponent(result[2]);
        }
        return null;
    };
    //设置cookie键值对
    //expDays过期时间(单位:天)
    w.setCookie=function(name,value,expDays){
        var defDomain=";Path=/;domain=.keking.cn";
        if(!!expDays && typeof expDays==='number'){
            var d=new Date();
            d.setDate(d.getDate()+expDays);
            document.cookie=name+"="+encodeURI(value)+defDomain+";expires="+d.toUTCString();
        }
        else{
            document.cookie=name+"="+encodeURI(value)+defDomain;
        }
    };
    //获取cookie指定键的值
    w.getCookie=function(name){
        if(document.cookie.length>0){
            var cs=document.cookie.indexOf(name+"=");
            if(cs!=-1){
                cs=cs+name.length+1;
                var ce=document.cookie.indexOf(";",cs);
                if(ce==-1){
                    ce=document.cookie.length;
                }
                return decodeURI(document.cookie.substring(cs,ce));
            }
        }
        return "";
    };
    //设置本地存储localStorage键值对
    w.setLocalStorage=function(key,val){
        if(!!key && !!val && (typeof key==="string" || typeof key==="number")){
            var thisKey=key+"";
            var thisVal="";
            if(typeof val==="object"){
                thisVal=thisVal+JSON.stringify(val);
            }
            else{
                thisVal=thisVal+val;
            }
            w.localStorage.setItem(thisKey,thisVal);
        }
    };
    //获取本地存储localStorage指定键的值
    w.getLocalStorage=function(key){
        var thisVal=null;
        if(!!key && (typeof key==="string" || typeof key==="number")){
            var thisKey=key+"";
            thisVal=w.localStorage.getItem(thisKey);
        }
        return thisVal;
    };
    //删除本地存储localStorage中指定的键值对
    w.removeLocalStorage=function(key){
        if(!!key && (typeof key==="string" || typeof key==="number")) {
            var thisKey = key+"";
            w.localStorage.removeItem(thisKey);
        }
    };
    //清除所有本地存储localStorage
    w.clearLocalStorage=function(){
        w.localStorage.clear();
    };
    //年-月-日
    w.timestampToDate1 = function (timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000;
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        return Y + M + D;
    };
    //xxxx年xx月xx日
    w.timestampToDate2 = function (timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000;
        var Y = date.getFullYear() + '年';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
        var D = (date.getDate() < 10 ? '0' + date.getDate(): date.getDate()) + '日' ;
        return Y + M + D;
    };
    //年-月-日 时-分-秒
    w.timestampToDate3 = function (timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000;
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ' ';
        var H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() + ':';
        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() + ':';
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() + '';
        return Y + M + D + H + m +s;
    };
    //动态加载script标签文件后执行回调(callback)
    w.loadScript=function(url,callback){
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (script.readyState){//IE
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                    script.onreadystatechange = null;
                    callback();
                }
            };
        }
        else {//Others
            script.onload = function(){
                callback();
            };
        }
        script.src = url;
        document.getElementsByTagName("body")[0].appendChild(script);
    };
})(window);



// WEBPACK FOOTER //
// ./src/static/js/global.js